export default __webpack_public_path__ + "static/media/overdelivering.b0e52103.svg";